import { computed, onMounted, ref } from "vue";
import buildAPI from "@/apiServices/buildAPI";

type BuildFooterOptions = {
  logErrors?: boolean;
};

export type BuildFooterData = {
  copyright: string;
  buildNo?: string;
  mode: string;
  buildTime?: string;
  serverName?: string;
  serverIP?: string;
  dbName?: string;
};

export function useBuildFooterData(options: BuildFooterOptions = {}) {
  const buildNo = ref("");
  const buildTime = ref("");
  const serverName = ref("");
  const serverIP = ref("");
  const dbName = ref("");
  const isDevMode = ref(false);

  async function fetchBuildInfo() {
    try {
      const response = await buildAPI.getBuildInfo();
      if (response.length > 0) {
        buildNo.value = response[0] ?? "";
        buildTime.value = response[1] ?? "";
        serverName.value = response[2] ?? "";
        serverIP.value = response[3] ?? "";
        isDevMode.value = (response[4] ?? "").toLowerCase() === "yes";
        dbName.value = response[5] ?? "?";
      }
    } catch (error) {
      if (options.logErrors) {
        console.error("Error fetching build data:", error);
      }
    }
  }

  const footerData = computed<BuildFooterData>(() => ({
    copyright: `Copyright \u00a9 ${new Date().getFullYear()} EdgeConneX`,
    buildNo: buildNo.value,
    mode: isDevMode.value ? "dev" : "prod",
    buildTime: buildTime.value,
    serverName: serverName.value,
    serverIP: serverIP.value,
    dbName: dbName.value,
  }));

  onMounted(() => {
    void fetchBuildInfo();
  });

  return {
    isDevMode,
    footerData,
    fetchBuildInfo,
  };
}
